<template>
  <div class="invoice_mini">
    <app-info :order="order" />
    <table class="table">
      <tbody>
        <tr
          v-for="item in items"
          :key="item.id"
        >
          <td>
            <div cols="12">
              {{ item.name | capitalize }}
            </div>
            <div
              cols="12"
              class="text-right"
            >
              <span class="mini-text">
                ({{ item.discount }}% Off reversed) {{ item.qty }} X
                {{ item.price }} =
              </span>
              {{ item.subTotal }}
            </div>
          </td>
        </tr>
        <tr>
          <td class="text-right">
            Total Refund ({{ order.totalItems }}
            {{ order.totalItems | pluralize(["item", "items"]) }}) :
            {{ order.subTotal | currency }}
          </td>
        </tr>
        <tr>
          <td class="text-right">
            <h5>
              Tax Fall (+ {{ order.taxRate }} %) :
              {{ order.taxAmount | currency }}
            </h5>
            <h5>
              Reverted Discount (- {{ order.discountRate }} %) :
              {{ order.discountedAmount | currency }}
            </h5>
            <h4>
              Total Refund:
              {{ order.totalAmount | currency }}
            </h4>
          </td>
        </tr>
      </tbody>
    </table>
    <terms-conditions />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Terms from "../common/Terms.vue";
import AppInfo from "../common/ComInfo.vue";
export default {
  components: {
    "terms-conditions": Terms,
    "app-info": AppInfo,
  },
  data() {
    return {
      items: {},
      order: {},
      payment: {},
    };
  },
  computed: {
    ...mapGetters({
      info: "misc/currentSale",
    }),
  },
  mounted() {
    this.getFromApi();
    Event.$emit("printSize");
    Event.$emit("loadTerms", "refundTerms");
  },
  methods: {
    active() {
      let id = this.info;
      if (this.$route.params.id) {
        id = this.$route.params.id;
      }
      return id;
    },
    getFromApi() {
      window.axios.get("/order/" + this.active()).then((response) => {
        this.$data.items = response.data.order.items;
        this.$data.order = response.data.order;
        this.$data.payment = response.data.payment;
        setTimeout(() => {
          window.print();
        }, 2000);
      });
    },
  },
};
</script>
